module.exports = __webpack_public_path__ + "img/吕秉海.afb3f72e.jpg";